import { createSignal } from 'solid-js';
import type { TagExploreMapMarker } from '@utils/tagsExploreMapMarkers';

const [tagsExploreMapMarkers, setTagsExploreMapMarkers] = createSignal<TagExploreMapMarker[]>([]);

export { tagsExploreMapMarkers, setTagsExploreMapMarkers };
